import { Box, Paper, Divider, Tabs, Tab } from "@mui/material";
import DealershipStyle from "./Dealership.styles";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../../../context/App.context";
import AppButton from "../../../base/AppButton.component";
import ArtifactsParent from "./tabs/ArtifactsParent.component";
import { FETCH_AVATARS, GET_DEALERSHIPS } from "../../../../graphql/query/query";
import { useMutation, useQuery } from "@apollo/client";
import { today } from "../../../../utils/Utils";
import NewDealershipFormComponent from "./tabs/NewDealershipForm.component";
import AvatarsComponent from "./tabs/Avatars.component";
import Integrations from "./dealershipServices/integrations/Integrations";
import { DEALERSHIP_AVATAR } from "../../../../graphql/mutation/mutation";
import WarrantyModule from "./tabs/WarrantyModule.component";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ overflow: "scroll", width: "100%", height: "100%", p: 0 }}
    >
      {value === index && (
        <Box width={"100%"} height={"100%"}>
          {children}
        </Box>
      )}
    </div>
  );
}
const EditDealershipTabs = ({ edit = true }) => {
  const app = useAppContext();
  const params = useParams();
  const navigate = useNavigate();

  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [getDealership, setGetDealership] = useState();
  const [value, setValue] = useState(0);
  const [disable, setDisable] = useState(false);
  const [isVoiceRepairTriggered, setIsVoiceRepairTriggered] = useState(false);
  console.log("newValue", edit, params, app?.dealershipId, value);

  useEffect(() => {
    if (value === 0 && !edit) {
      navigate("/createDealership/dealership");
      app.setDealershipId(null);
    }
    if (value === 0 && !(params?.dealershipId || app?.dealershipId)) {
      setDisable(true);
    }
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0 && !edit) {
      navigate("/createDealership/dealership");
      app.setDealershipId(null);
    }
    if (newValue === 1 && !edit) {
      navigate(
        `/createDealership/${
          params?.dealershipId || app?.dealershipId
        }/artifacts`
      );
    }
    if (newValue === 2 && !edit) {
      navigate(
        `/createDealership/${params?.dealershipId || app?.dealershipId}/avatars`
      );
    }
  };

  const {
    data: dealershipData,
    loading,
    refetch,
  } = useQuery(GET_DEALERSHIPS, {
    variables: {
      filterInput: {
        dealership_id: parseInt(params.dealershipId),
        city: "",
        dealership_name: "",
        email: "",
        date: today,
        rowsPerPage: app.fetchData.a_rowsPerPage,
        pageCount: app.fetchData.a_pageCount,
      },
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    skip: !params?.dealershipId || !edit,
  });
  const { data: avatarsData } = useQuery(FETCH_AVATARS, {
    skip: !edit,
  });
  const [dealershipAvatar] = useMutation(DEALERSHIP_AVATAR);

  useEffect(() => {
    if (dealershipData?.getDealerships?.dealerships?.length > 0) {
      const getDealership = dealershipData?.getDealerships?.dealerships.find(
        (data) => data.dealership_id === parseInt(params.dealershipId)
      );
      setGetDealership(getDealership);
      const input = getDealership?.avatar;
      setSelectedAvatar(input?.avatar_id);
    }
  }, [dealershipData]);

  useEffect(() => {
    const dealershipAvatarData = getDealership?.avatar;
    const selectedAvatarData = avatarsData?.fetchAvatars?.avatars?.find(
      (avatar) => avatar?.avatar_id === dealershipAvatarData?.avatar_id,
    );

    if (
      !edit ||
      isVoiceRepairTriggered ||
      !params?.dealershipId ||
      !dealershipAvatarData?.avatar_id ||
      dealershipAvatarData?.voice_id ||
      !selectedAvatarData?.id
    ) {
      return;
    }

    setIsVoiceRepairTriggered(true);
    dealershipAvatar({
      variables: {
        avatarInput: {
          avatar_id: dealershipAvatarData?.avatar_id,
          gender: selectedAvatarData?.gender,
          dealership_id: parseInt(params.dealershipId),
          id: selectedAvatarData?.id,
        },
      },
    }).then(() => {
      refetch?.();
    });
  }, [
    avatarsData,
    dealershipAvatar,
    edit,
    getDealership,
    isVoiceRepairTriggered,
    params?.dealershipId,
    refetch,
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "10px",
      }}
    >
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="dealership details" {...a11yProps(0)} />
          <Tab
            label="sales aids / artifacts"
            {...a11yProps(1)}
            disabled={disable}
          />
          <Tab label="avatars" {...a11yProps(2)} disabled={disable} />
          <Tab label="Integrations" {...a11yProps(3)} disabled={disable} />
          <Tab label="Warranty" {...a11yProps(4)} disabled={disable} />
        </Tabs>
      </Box>
      <Paper sx={DealershipStyle.editPaper}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                margin: "16px",
              }}
            >
              <h2>Dealerships loading..</h2>
            </Box>
          ) : (
            <>
              <CustomTabPanel value={value} index={0}>
                <NewDealershipFormComponent
                  data={getDealership}
                  edit={edit}
                  refetchdealer={refetch}
                  setValue={setValue}
                />
              </CustomTabPanel>

              <CustomTabPanel value={value} index={1}>
                <ArtifactsParent
                  data={getDealership}
                  edit={edit}
                  selectedAvatar={selectedAvatar}
                  refetch={refetch}
                />
              </CustomTabPanel>

              <CustomTabPanel value={value} index={2}>
                <AvatarsComponent
                  data={getDealership}
                  edit={edit}
                  refetch={edit ? refetch : null}
                  selectedAvatar={selectedAvatar}
                  setSelectedAvatar={setSelectedAvatar}
                />
              </CustomTabPanel>

              <CustomTabPanel value={value} index={3}>
                <Integrations
                  data={getDealership}
                  edit={edit}
                  refetch={edit ? refetch : null}
                />
              </CustomTabPanel>

              <CustomTabPanel value={value} index={4}>
                <WarrantyModule
                  data={getDealership}
                  edit={edit}
                  refetch={edit ? refetch : null}
                />
              </CustomTabPanel>
            </>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default EditDealershipTabs;